module.exports = __webpack_public_path__ + "static/parade-2020-house25-a2ad4091442dd6e0ce5778f3bb5ac72b.jpg";